import React from "react";
import { CheckboxEditor } from "../../../../../../react-core/Html/CheckboxEditor";
import { FormComponent } from "../../../../../../react-core/Html/FormComponent";
import { NumberTextBoxEditor } from "../../../../../../react-core/Html/NumberTextBoxEditor";
import { TextBoxEditor } from "../../../../../../react-core/Html/TextBoxEditor";
import { JsonDateParser } from "../../../../../../react-core/Utils/JsonDateParser";
import { CustomerStatus } from "../../../../../../Wrap/Constants/Enums/Domain/CustomerStatus";
import { CustomerSearchModel } from "../../../../../../Wrap/Models/Models/Customer/CustomerSearch/CustomerSearchModel";
import { CustomerSearchResult } from "../../../../../../Wrap/Models/Models/Customer/CustomerSearch/CustomerSearchResult";
import { Alert } from "../../../../../Shared/Components/Alert";
import { AlertType } from "../../../../../Shared/Entities/Constants/AlertConstants";
import { ITableConfig, Table } from "../../../../../Shared/Table/Table";
import { getQueryParameters } from "../../../../../Shared/Wizards/Entities/QueryParametersHelper";
import { Navigator } from "../../../../../Shared/Wizards/Entities/Navigator";
import { Urls } from "../../../../Urls";
import { Filter } from "../../AddClient/Components/ClientType/Filter";
import { ButtonLabels } from "../../AddClient/Resource/Contents";
import { CustomerSearchAction, ICustomerSearchQuery } from "../../ClientRecord/Action/CustomerSearchAction";
import { customerStatusMap } from "../../ClientRecord/Resource/Contents";
import { AdviserInfoMessage, SelectCustomerErrorMsg, SelectCustomerSuccessMsg } from "../Resource/Content";
import { CustomerDetailsPopup } from "./CustomerDetailsPopUp";
import { RoleType } from "../../../../../../Wrap/Constants/Enums/RoleType";
import { EntityType } from "../../../../../../Wrap/Constants/Enums/EntityType";
import { checkPermission } from "../../../../../Shared/Permission/PermissionHelper";
import { UserClaim } from "../../../../../../Wrap/Constants/Enums/UserClaim";

interface ISelectCustomersProps {}
interface ISelectCustomerState {
    ownerAdviserId: number;
    selectedCustomers: CustomerSearchResult[];

    customerId: number;
    firstName: string;
    lastName: string;

    isSearching: boolean;
    searchResult: CustomerSearchModel;
    currentPage: number;

    showErrorMsg: boolean;
    showSuccessMsg: boolean;
}

export class SelectCustomers extends FormComponent<ISelectCustomersProps, ISelectCustomerState> {
    constructor(props: any) {
        super(props);
        this.state = {
            ownerAdviserId: null,
            selectedCustomers: [],
            customerId: null,
            firstName: "",
            lastName: "",
            isSearching: false,
            searchResult: null,
            currentPage: 1,
            showErrorMsg: false,
            showSuccessMsg: false,
        };
    }

    componentDidMount() {
        const isSuccessful = getQueryParameters()["flag"];
        if (isSuccessful == "1") {
            this.setState({ showSuccessMsg: true });
        }
    }

    private searchCustomers(currentPage: number) {
        this.setState({ isSearching: true });
        const { customerId, firstName, lastName, ownerAdviserId } = this.state;
        const customerSearchQuery: ICustomerSearchQuery = {
            customerId: customerId,
            customerStatus: CustomerStatus.NotSpecified,
            firstName: firstName != "" ? firstName + "%" : null,
            lastName: lastName != "" ? lastName + "%" : null,
            dateOfBirth: null,
            TaxIdentifier: null,
            clAccountId: null,
            customerRole: RoleType.NotSpecified,
            visibleToAdviserId: null,
            entityId: ownerAdviserId,
            entityType: EntityType.Advisor,
        };
        CustomerSearchAction.searchCustomers(customerSearchQuery, currentPage, 10, (data: CustomerSearchModel) => {
            this.setState({ searchResult: data, isSearching: false });
        });
    }

    private goToNextStep() {
        if (this.state.selectedCustomers.length == 2) {
            this.setState({ showErrorMsg: false });
            console.log("Go to next step");
            console.log(this.state.selectedCustomers);
            Navigator.navigateTo(Urls.get().main.CustomerMergeDetails, {
                scrollAfterNavigating: true,
                queryParamsObject: {
                    customerid1: this.state.selectedCustomers[0].CustomerId,
                    customerid2: this.state.selectedCustomers[1].CustomerId,
                },
            });
        } else {
            this.setState({ showErrorMsg: true });
        }
    }

    private renderCustomersSearch() {
        return (
            <>
                <h3>Customers to merge</h3>
                <div className="row ml-0">
                    <NumberTextBoxEditor
                        label="Customer ID"
                        onChange={(v) => this.setState({ customerId: v })}
                        value={this.state.customerId}
                        maxLength={15}
                        cssWrapper="control-size-245 mr-10"
                    />
                    <TextBoxEditor
                        label="First name"
                        onChange={(v) => this.setState({ firstName: v })}
                        value={this.state.firstName}
                        maxLength={100}
                        cssWrapper="control-size-245 mr-10"
                    />
                    <TextBoxEditor
                        label="Surname"
                        onChange={(v) => this.setState({ lastName: v })}
                        value={this.state.lastName}
                        maxLength={100}
                        cssWrapper="control-size-245 mr-10"
                    />
                    <div className="col-auto">
                        <button
                            className={`btn primary mt-30 ${this.state.isSearching ? "is-busy" : ""}`}
                            onClick={() => this.searchCustomers(1)}
                        >
                            Search
                        </button>
                    </div>
                </div>
            </>
        );
    }

    private getSelectCustomerColConfig(isSelectedCustomerTable: boolean): ITableConfig[] {
        return [
            {
                title: "Select",
                key: "CustomerId",
                render: (data: number, row) => {
                    if (isSelectedCustomerTable) {
                        return (
                            <button
                                className="delete-button"
                                disabled={false}
                                onClick={() => {
                                    const list = this.state.selectedCustomers.filter((x) => x.CustomerId != data);
                                    this.setState({
                                        selectedCustomers: list,
                                        showSuccessMsg: false,
                                        showErrorMsg: false,
                                    });
                                }}
                            >
                                <span className="icon" aria-hidden="true"></span>
                            </button>
                        );
                    } else {
                        return (
                            <CheckboxEditor
                                value={this.state.selectedCustomers.some((x) => x.CustomerId == data)}
                                onChange={(v) => {
                                    if (v) {
                                        const list = this.state.selectedCustomers;
                                        list.push(row);
                                        this.setState({
                                            selectedCustomers: list,
                                            showSuccessMsg: false,
                                            showErrorMsg: false,
                                        });
                                    } else {
                                        const list = this.state.selectedCustomers.filter((x) => x.CustomerId != data);
                                        this.setState({
                                            selectedCustomers: list,
                                            showSuccessMsg: false,
                                            showErrorMsg: false,
                                        });
                                    }
                                }}
                                disabled={
                                    this.state.selectedCustomers.some((x) => x.CustomerId == data) ||
                                    this.state.selectedCustomers.length > 1
                                }
                            />
                        );
                    }
                },
            },
            {
                title: "Customer ID",
                key: "CustomerId",
            },
            {
                title: "Customer name",
                render: (data, row: CustomerSearchResult) => {
                    return (
                        <>
                            {row.FirstName} {row.LastName}
                        </>
                    );
                },
            },
            {
                title: "Date of birth",

                render: (data, row: CustomerSearchResult) => {
                    return (
                        <CustomerDetailsPopup
                            customerId={row.CustomerId}
                            displayText={JsonDateParser.getFormatDate(row.DateOfBirth, "dd/MM/yyyy")}
                        />
                    );
                },
            },
            {
                title: "Status",
                key: "CustomerStatus",
                render: (data, row: CustomerSearchResult) => {
                    return row.IsProspect ? "Prospect" : customerStatusMap[data];
                },
            },
        ];
    }

    public render(): JSX.Element {
        return (
            <>
                <h2>Customer merge</h2>
                {this.state.showSuccessMsg && (
                    <Alert alertType={AlertType.Success} message={SelectCustomerSuccessMsg} />
                )}
                {this.state.showErrorMsg && <Alert alertType={AlertType.Error} message={SelectCustomerErrorMsg} />}
                {this.state.ownerAdviserId && (
                    <Alert
                        alertType={AlertType.Warning}
                        message={
                            <>
                                {AdviserInfoMessage}
                                {checkPermission(UserClaim.AdviserPortalDluFindUsersCanView) && (
                                    <a
                                        href="javascript:void(0);"
                                        className="hyperlink"
                                        onClick={() => window.location.assign(`/admin/users/findusers.aspx`)}
                                    >
                                        here
                                    </a>
                                )}
                            </>
                        }
                    />
                )}

                <Filter
                    data={null}
                    onRef={(ref) => {}}
                    onFilterSelectionChange={(data) => {
                        if (!data?.Prospect?.OwnerAdviserId) {
                            this.setState({
                                ownerAdviserId: null,
                                selectedCustomers: [],
                                customerId: null,
                                firstName: "",
                                lastName: "",
                                isSearching: false,
                                searchResult: null,
                                currentPage: 1,
                                showErrorMsg: false,
                            });
                        } else {
                            this.setState({
                                ownerAdviserId: data?.Prospect.OwnerAdviserId,
                                showSuccessMsg: false,
                                showErrorMsg: false,
                                selectedCustomers: [],
                            });
                        }
                    }}
                    onChange={() => {}}
                />
                {this.state.ownerAdviserId && this.renderCustomersSearch()}
                {this.state.ownerAdviserId && this.state.searchResult && (
                    <>
                        <Table
                            data={this.state.searchResult.CustomerList}
                            col={this.getSelectCustomerColConfig(false)}
                            showEmptyMsg
                            cssWrapper="mb-60"
                            needPagination={{
                                totalNumOfResult: this.state.searchResult.TotalNumberOfResults,
                                onPaginationChange: (pageIndex, pageSize) => {
                                    this.setState({ currentPage: pageIndex });
                                    this.searchCustomers(pageIndex);
                                },
                                currentPage: this.state.currentPage,
                            }}
                        />
                        <h3>Customers selected</h3>
                        <Table
                            data={this.state.selectedCustomers}
                            col={this.getSelectCustomerColConfig(true)}
                            showEmptyMsg
                            emptyMsg="No customers have been selected yet"
                            cssWrapper="mb-60"
                            needPagination={{
                                totalNumOfResult: this.state.selectedCustomers.length,
                                onPaginationChange: (pageIndex, pageSize) => {
                                    {
                                    }
                                },
                                currentPage: 1,
                            }}
                        />
                        <div className="page-actions">
                            <div className="action-primary">
                                <button className="next-button" onClick={() => this.goToNextStep()}>
                                    <span className="text">{ButtonLabels.nextLabel}</span>
                                    <span className="icon" aria-hidden="true"></span>
                                </button>
                            </div>
                        </div>
                    </>
                )}
            </>
        );
    }
}
